<template>
  <div>
    <spinner-loader :loading="loading" />
    <campaign-form
      v-if="!loading"
      :campaign="campaign"
      :submit="editCampaign"
      :send-campaign="sendCampaign"
    />
  </div>
</template>

<script>
import CampaignForm from '@/components/Marketing/CampaignForm.vue'
import Campaigns from '@/compositions/Campaigns/CampaignsAPI'
import handleAlerts from '@/compositions/common/handleAlerts'
import SpinnerLoader from '@/components/Table/SpinnerLoader.vue'

export default {
  name: 'EditCampaign',
  components: { CampaignForm, SpinnerLoader },
  data() {
    return {
      loading: false,
    }
  },
  setup() {
    const { successfulOperationAlert } = handleAlerts()
    const {
      campaign, showRequest, updateRequest, sendRequest,
    } = Campaigns()
    return {
      campaign, showRequest, updateRequest, sendRequest, successfulOperationAlert,
    }
  },
  created() {
    this.getCampaign()
  },
  methods: {
    getCampaign() {
      this.loading = true
      this.showRequest(this.$route.params.id, { embed: 'header' }).then(res => {
        this.campaign = {
          ...res.data.data,
          attendees: res.data.data.emails?.map(email => ({ email })),
          events: res.data.data.events.map(event => ({ ...event, title: event.title.en })),
        }
      }).finally(() => {
        this.loading = false
      })
    },
    editCampaign() {
      return this.updateRequest().then(() => {
        this.successfulOperationAlert('Campaign is updated successfully')
        this.redirect()
      })
    },
    sendCampaign() {
      this.$set(this.campaign, 'status', 2)
      return this.updateRequest().then(() => this.sendRequest().then(() => {
        this.successfulOperationAlert('Campaign is sent successfully')
        this.$router.push({ name: 'organization-profile' })
      }))
    },
    redirect() {
      this.$router.push({ name: 'organization-profile', query: { firstTabIndex: 1 } })
    },
  },
}
</script>

<style>

</style>
